import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import React from "react";
import BatteryIndicator from "./BatteryIndicator";
import Doorstatus from "./Doorstatus";
import Gauge from "./Gauge";
import Tachometer from "./Tachometer";
import { Temperature } from "./Temperature";
import DashboardSvg from "@assets/dashboard.svg";

interface CockpitProps {
  speed: number;
  rpm?: number;
  inTemp?: number;
  outTemp?: number;
  engineTemp?: number;
  fuelLvl?: number;
  adBlueLvl?: number;
  soc?: number;
  isCharging: number;
  door1?: number;
  door2?: number;
  door3?: number;
  isDriving: boolean;
}

export default function Cockpit(props: CockpitProps) {
  const isSmallScreen = useMediaQuery("(max-width:900px)");

  const {
    speed,
    rpm,
    inTemp,
    outTemp,
    engineTemp,
    fuelLvl,
    adBlueLvl,
    isCharging,
    soc,
    door1,
    door2,
    door3,
    isDriving,
  } = props;
  const isElectric = isCharging !== -1;
  return (
    <Box
      sx={{
        width: isSmallScreen ? "50%" : "100%",
        height: "auto",
        position: "relative",
        mx: "auto",
      }}
    >
      <img
        src={DashboardSvg}
        alt="Dashboard"
        style={{
          height: "100%",
          width: "100%",
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          alignItems: "center",
          width: "100%",
          height: "90%",
          position: "absolute",
          top: "20%",
          right: 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            width: "50%",
            height: "35%",
            mx: "auto",
            mt: "-2%",
          }}
        >
          <Tachometer value={fuelLvl ?? 0} max={100} label={"Fuel"} />
          <BatteryIndicator isCharging={isCharging} soc={soc} />
          <Tachometer value={adBlueLvl ?? 0} max={100} label={"AdBlue"} />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            alignItems: "center",
            width: "80%",
            mx: "auto",
            gap: "5%",
            mt: isSmallScreen ? "-8%" : "-4%",
          }}
        >
          <Gauge value={isDriving ? speed : 0} max={180} label="km/h" />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
              gap: "1vw",
              mt: "-8%",
              width: "100%",
            }}
          >
            <Temperature label="Innen" value={inTemp ?? -1} />
            <Temperature label="Außen" value={outTemp ?? -1} />
            <Temperature label="Motor" value={engineTemp ?? -1} />
          </Box>
          <Gauge
            value={rpm && isDriving ? (isElectric ? rpm / 1000 : rpm) : 0}
            isElectric={isElectric}
            max={isElectric ? 300 : 6000}
            label={isElectric ? "kW" : "rpm"}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "30%",
            height: "60%",
            mt: "-18%",
            justifyContent: "space-evenly",
          }}
        >
          <Doorstatus door={1} status={door1 ?? -1} />
          <Doorstatus door={2} status={door2 ?? -1} />
          <Doorstatus door={3} status={door3 ?? -1} />
        </Box>
      </Box>
    </Box>
  );
}
